const appInfo = {
    title: 'QSolutions'
}; 

export default appInfo;

